import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=166e1e4a&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=166e1e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e1e4a",
  null
  
)

export default component.exports